<script>
import feather from 'feather-icons';
import FooterCopyright from './FooterCopyright.vue';
export default {
	components: { FooterCopyright },
	data() {
		return {
      envire : '',
		};
	},
	mounted() {
		feather.replace();
    if(window.location.href.indexOf("localhost") < 0) {
      this.envire = 'http://c.statcounter.com/11008584/0/38203880/1/';
    }
     console.log("mode is " + this.envire)
	},
	updated() {
		feather.replace();
	},
};
</script>

<template>
	<div id="phoneno">
		<div
			class="pt-20 sm:pt-30 pb-8 mt-20 border-t-2 border-primary-light dark:border-secondary-dark"
		>
			<!-- Footer social links -->
			<div
				class="flex flex-col justify-center items-center mb-12 sm:mb-20"
			>
				<p
					class="font-general-semibold text-3xl sm:text-4xl font-semibold text-primary-dark dark:text-primary-light mb-5"
				>
					Umów wizytę
				</p>



<!--        <div class="flex items-start gap-3 bg-red-100 border-2 border-red-400 border-l-4 border-l-red-600 text-red-900 px-5 py-4 rounded-r-md text-xl font-bold leading-relaxed">-->
<!--          <svg class="w-7 h-7 flex-shrink-0 mt-0.5 text-red-600" fill="currentColor" viewBox="0 0 20 20">-->
<!--            <path fill-rule="evenodd" d="M18 10A8 8 0 11 2 10a8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />-->
<!--          </svg>-->
<!--            <p> W dniach od 7 do 16 sierpnia z powodu urlopu gabinet ortopedyczny jest nieczynny.</p>-->
<!--          </div>-->

        <div class="flex flex-col justify-center sm:block pt-4">
          <p
              class="font-general-medium mt-2 text-lg sm:text-xl  xl:text-2xl text-center sm:text-left text-ternary-dark dark:text-primary-light "
          >
            Zapisy pacjentów pod numerami:<br>
            <a :href="`tel:606379728`" class="font-general-bold hover:text-green-500" >606 379 728</a><br> <a :href="`tel:694004063`" class="font-general-bold hover:text-green-500">694 004 063</a><br>
            od poniedziałku  do piątku w godz. 10.00-18.00, w soboty 10.00-14.00
          </p>
          <p
              class="font-general-medium mt-2 text-lg sm:text-xl  xl:text-2xl text-center sm:text-left leading-none text-green-600"
          >
            Przyjęcia od wtorku do soboty
            po uzgodnieniu telefonicznym
            dnia i godziny wizyty.
          </p>
        </div>

			</div>

			<!-- Footer copyright -->
			<FooterCopyright />
      <div class="hide">
          <div id="statcounter_image" style="display:inline;">
              <a>
                  <img :src="this.envire" style="border:none;" />
              </a>
          </div>
      </div>
		</div>
	</div>
</template>

<style scoped></style>
